/**
 * Simple S3 Configuration utilities
 */
export const S3Config = {
    // Only use CDN URL as other methods don't have permissions
    CDN_URL: import.meta.env.VITE_AWS_CDN_URL || '',
    UPLOADS_PREFIX: import.meta.env.VITE_AWS_CDN_URL_UPLOADS_PREFIX || 'uploads',

    // Get full URL for cache key using only CDN
    getFullUrl: (key: string): string => {
        const cdnUrl = S3Config.CDN_URL;

        if (!cdnUrl) {
            throw new Error('CDN URL not configured. Set VITE_AWS_CDN_URL in environment variables.');
        }

        const normalizedKey = key.replace(/^\/+/, '');
        return `${cdnUrl.replace(/\/+$/, '')}/${normalizedKey}`;
    },

    /** Build CDN URL under uploads prefix. Passes through absolute http(s) URLs. */
    getUploadsUrl: (path: string | null | undefined): string => {
        if (!path) return '';
        if (/^https?:\/\//i.test(path)) return path;

        const prefix = S3Config.UPLOADS_PREFIX.replace(/^\/+|\/+$/g, '') || 'uploads';
        const key = path.replace(/^\/+/, '').replace(new RegExp(`^${prefix}/`), '');

        return S3Config.getFullUrl(`${prefix}/${key}`);
    },
};

export const { getFullUrl, getUploadsUrl } = S3Config;
